export default __webpack_public_path__ + "static/media/cyberbearzarmy_middle .dbd1f6e7.svg";